export const MARKETPLACE_REPORT_REASONS = [
  "MISREPRESENTATION",
  "OWNERSHIP_CONCERN",
  "ANIMAL_WELFARE",
  "SCAM",
  "OTHER",
] as const;

export const MARKETPLACE_REPORT_REASON_MESSAGE_KEYS = {
  MISREPRESENTATION: "reasonMisrepresentation",
  OWNERSHIP_CONCERN: "reasonOwnership",
  ANIMAL_WELFARE: "reasonWelfare",
  SCAM: "reasonScam",
  OTHER: "reasonOther",
} as const satisfies Record<
  (typeof MARKETPLACE_REPORT_REASONS)[number],
  string
>;
